/* eslint-disable */
// @ts-nocheck

import { StyleSheet, View } from '@react-pdf/renderer'

import globalStyles from '../../helpers/globalStyles'
import Cell from './Cell'
import Column from './Column'
import Row from './Row'

const styles = StyleSheet.create({
  total: {
    backgroundColor: '#fff',
    width: '100%',
    color: '#000',
  },
  row: {
    borderBottom: 1,
    borderColor: '#ccc',
    minHeight: 28,
  },
})

const TableFooter = ({
  values,
  widths,
}: {
  values: string[]
  widths?: number[]
}) => {
  return (
    <View style={styles.total}>
      <Row style={styles.row}>
        {values.map((value, index) => {
          const [_, style] = typeof value === 'string' ? value.split('~') : []
          return (
            <Column
              style={
                index === 0
                  ? [globalStyles.firstColumn]
                  : [
                      index !== values.length - 1
                        ? globalStyles.nColumn
                        : globalStyles.lastColumn,
                      { width: widths ? widths[index - 1] + '%' : '15%' },
                      globalStyles[style as keyof typeof globalStyles],
                    ]
              }
            >
              <Cell data={value} />
            </Column>
          )
        })}
      </Row>
    </View>
  )
}
export default TableFooter
